'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Application = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _auroraJavascriptUtils = require('@unitedtraders/aurora-javascript-utils');

var _eventEmitter = require('event-emitter');

var _eventEmitter2 = _interopRequireDefault(_eventEmitter);

var _NotificationUtils = require('./notification/NotificationUtils');

var _superAgentUtils = require('./superAgentUtils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Application contains all functional domains
 */
var Application = function () {
    function Application(options) {
        _classCallCheck(this, Application);

        var appName = options.appName,
            history = options.history;


        _auroraJavascriptUtils.assert.string(appName);
        _auroraJavascriptUtils.assert.object(history);

        this.appName = appName;
        this.logger = _auroraJavascriptUtils.log.getLogger(appName);
        this.initOptions = options; // for dev-purpose
        this.domains = {};
        this.attributes = {}; // application specific attributes (like attributes ServletContext)
        this.history = history;
        this.notificationUtils = new _NotificationUtils.NotificationUtils(this.history);
        this.readiness = null;
        this.readyPromise = null;
        this._superAgent = null;
    }

    _createClass(Application, [{
        key: 'registerDomain',
        value: function registerDomain(name, domain) {
            var _this = this;

            _auroraJavascriptUtils.assert.string(name);
            _auroraJavascriptUtils.assert.object(domain);

            if (this.domains[name]) {
                throw new Error('Domain with name \'' + name + '\' already registered ');
            }

            if (typeof domain.emit !== 'function') {
                domain.emit = function (event) {
                    for (var _len = arguments.length, params = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
                        params[_key - 1] = arguments[_key];
                    }

                    return _this.emit.apply(_this, [event].concat(params));
                };
                if (typeof domain.setupListeners === 'function') {
                    domain.setupListeners(this, name);
                }
            }

            this.domains[name] = domain;
        }
    }, {
        key: 'getDomain',
        value: function getDomain(name) {
            _auroraJavascriptUtils.assert.string(name);

            var domain = this.domains[name];

            if (!domain) {
                throw new Error('can\'t find domain with name \'' + name + '\'');
            }

            return domain;
        }
    }, {
        key: 'registerAttribute',
        value: function registerAttribute(name, value) {
            _auroraJavascriptUtils.assert.string(name);

            if (this.attributes[name]) {
                throw new Error('Attributes with name \'' + name + '\' already registered ');
            }

            this.attributes[name] = value;
        }
    }, {
        key: 'getAttribute',
        value: function getAttribute(name) {
            _auroraJavascriptUtils.assert.string(name);

            var atrtibute = this.attributes[name];

            if (!atrtibute) {
                throw new Error('can\'t find attribute with name \'' + name + '\'');
            }

            return atrtibute;
        }
    }, {
        key: 'getRoles',
        value: function getRoles() {
            return Object.values(this.domains).reduce(function (result, domain) {
                return [].concat(_toConsumableArray(result), _toConsumableArray(domain.Role.enumValues));
            }, []);
        }
    }, {
        key: 'deinit',


        // Destructor. This must tear down the application state to avoid leaks
        // in Node.js when doing SSR.
        // TODO review: is there something we need to destroy here?
        value: function deinit() {}
    }, {
        key: 'superAgent',
        get: function get() {
            var _this2 = this;

            if (!this._superAgent) {
                // lazy initialization because authorization not available on app startup
                _auroraJavascriptUtils.assert.object(this.authorization);

                var authorizationTokenFailed = function authorizationTokenFailed(error) {
                    setTimeout(function () {
                        window.location.reload();
                    }, 3000);

                    _this2.notificationUtils.showNotification({
                        message: 'Authorization expired',
                        level: 'error'
                    });

                    throw error;
                };

                this._superAgent = (0, _superAgentUtils.getAuthorizedSuperAgent)(function () {
                    return _this2.authorization.getAuthorizationHeaderValue();
                }, authorizationTokenFailed);
            }

            return this._superAgent;
        }
    }]);

    return Application;
}();

(0, _eventEmitter2.default)(Application.prototype);

exports.Application = Application;


//////////////////
// WEBPACK FOOTER
// ./~/@unitedtraders/application-bootstrapper/dist/Application.js
// module id = 1296
// module chunks = 118